import { validateSectionField } from 'actions/entities/sections';
import { fetchSender } from 'actions/entities/sender';
import { setFieldValue } from 'actions/ui/ui';
import { Field } from 'components/Field/Field';
import type { FieldValue } from 'models';
import { useSelector } from 'react-redux';
import type { RootState } from 'reducers/types';
import { getFieldById } from 'selectors/entities/fields/fields';
import { useDispatch } from 'store/configureStore';
import { useTranslations } from 'utils';

type CountrySelectorProps = {
  onChange: (countryCode: string) => void;
};

export const CountrySelector = ({ onChange }: CountrySelectorProps) => {
  const i18n = useTranslations();
  const dispatch = useDispatch();
  const countryField = useSelector((state: RootState) =>
    getFieldById(state, 'sender_country'),
  );
  const handleCountryChange = async (name: string, value: FieldValue) => {
    if (countryField.defaultValue !== value) {
      dispatch(setFieldValue(name, value));
      dispatch(fetchSender());
      dispatch(validateSectionField(name));
      onChange(value as string);
    }
  };

  if (countryField) {
    return (
      <div className="mb-4 relative self-start">
        <Field
          field={{ ...countryField, label: i18n.t('country.label') }}
          onChange={handleCountryChange}
        />
      </div>
    );
  }
  return null;
};
